// 診断結果ロジックを元に結果アイテムのSlug情報を取得
// eslint-disable-next-line import/prefer-default-export
export const getResultItemSlugsByDiagnosisLogic = (
  stylistDiagnosisResults,
  sublimicDiagnosisLogics,
  authSalonSettingData,
  logicName,
  selectedItem
) => {
  // console.log('stylistDiagnosisResults', stylistDiagnosisResults);
  // console.log('sublimicDiagnosisLogics', sublimicDiagnosisLogics);

  // 選択済みActivity : 本日の施術内容
  const getSelectedActivity = () => {
    // 0:Cut ans-cut
    // 1:Head Spa ans-spa
    // 2:Hair Treatment ans-treat
    // 3:Straitening ans-streat
    // 4:Perm ans-perm
    // 5:Color ans-color
    const arr = [null, null, null, null, null, null];
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.treatments &&
      stylistDiagnosisResults.result.treatments.answers
    ) {
      for (let i = 0; i < stylistDiagnosisResults.result.treatments.answers.length; i += 1) {
        const answer = stylistDiagnosisResults.result.treatments.answers[i];
        if (answer === 'ans-cut') {
          arr[5] = answer;
        } else if (answer === 'ans-spa') {
          arr[4] = answer;
        } else if (answer === 'ans-treat') {
          arr[3] = answer;
        } else if (answer === 'ans-streat') {
          arr[2] = answer;
        } else if (answer === 'ans-perm') {
          arr[1] = answer;
        } else if (answer === 'ans-color') {
          arr[0] = answer;
        }
      }
      return arr.filter(val => {
        return !(val === null);
      })[0];
    }
    return null;
  };

  // 選択済みTime : 詳細検索かクイック検索か
  const getSelectedTime = () => {
    const useDiagnosis = localStorage.getItem('useDiagnosis');
    if (useDiagnosis === 'yes') {
      return 'yes';
    }
    return 'no';
  };

  // 選択済みResilience : 希望の仕上がり
  const getSelectedResilience = () => {
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.hairDiagnosis &&
      stylistDiagnosisResults.result.hairDiagnosis.hearing &&
      stylistDiagnosisResults.result.hairDiagnosis.hearing.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.hairDiagnosis &&
        stylistDiagnosisResults.result.hairDiagnosis.hearing &&
        stylistDiagnosisResults.result.hairDiagnosis.hearing.Questions;
      for (let i = 0; i < Questions.length; i += 1) {
        if (Questions[i].slug === 'fq-wanthair') {
          return Questions[i].answers;
        }
      }
    }
    return [];
  };

  // 選択済みDamageLevel : ダメージレベル
  const getSelectedDamageLevel = () => {
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.hairDiagnosis &&
      stylistDiagnosisResults.result.hairDiagnosis.stylistDiagnosis &&
      stylistDiagnosisResults.result.hairDiagnosis.stylistDiagnosis.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.hairDiagnosis &&
        stylistDiagnosisResults.result.hairDiagnosis.stylistDiagnosis &&
        stylistDiagnosisResults.result.hairDiagnosis.stylistDiagnosis.Questions;
      for (let i = 0; i < Questions.length; i += 1) {
        if (Questions[i].slug === 'fq-damagelevel') {
          return Questions[i].answers;
        }
      }
    }
    return [];
  };

  // 選択済みRedness : 希望の仕上がり
  const getSelectedWantToBe = () => {
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.scalpDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.hearing &&
      stylistDiagnosisResults.result.scalpDiagnosis.hearing.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.scalpDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.hearing &&
        stylistDiagnosisResults.result.scalpDiagnosis.hearing.Questions;
      for (let i = 0; i < Questions.length; i += 1) {
        if (Questions[i].slug === 'fq-wantscalp') {
          return Questions[i].answers;
        }
      }
    }
    return [];
  };

  // 選択済みRedness : 赤み
  const getSelectedRedness = () => {
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.scalpDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.scalpDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions;
      for (let i = 0; i < Questions.length; i += 1) {
        if (Questions[i].slug === 'fq-redness') {
          return Questions[i].answers;
        }
      }
    }
    return [];
  };

  // 選択済みConcerns : 毛髪に関する一番の悩み
  const getSelectedConcerns = () => {
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.hairDiagnosis &&
      stylistDiagnosisResults.result.hairDiagnosis.hearing &&
      stylistDiagnosisResults.result.hairDiagnosis.hearing.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.hairDiagnosis &&
        stylistDiagnosisResults.result.hairDiagnosis.hearing &&
        stylistDiagnosisResults.result.hairDiagnosis.hearing.Questions;
      for (let i = 0; i < Questions.length; i += 1) {
        if (Questions[i].slug === 'fq-mostconcern') {
          return Questions[i].answers;
        }
      }
    }
    return [];
  };

  // 選択済みFizziness : くせ
  const getSelectedFizziness = () => {
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.hairDiagnosis &&
      stylistDiagnosisResults.result.hairDiagnosis.stylistDiagnosis &&
      stylistDiagnosisResults.result.hairDiagnosis.stylistDiagnosis.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.hairDiagnosis &&
        stylistDiagnosisResults.result.hairDiagnosis.stylistDiagnosis &&
        stylistDiagnosisResults.result.hairDiagnosis.stylistDiagnosis.Questions;
      for (let i = 0; i < Questions.length; i += 1) {
        if (Questions[i].slug === 'fq-curly') {
          return Questions[i].answers;
        }
      }
    }
    return [];
  };

  // 選択済みOillness : 皮脂量
  const getSelectedOillness = () => {
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.scalpDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.scalpDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions;
      for (let i = 0; i < Questions.length; i += 1) {
        if (Questions[i].slug === 'fq-sebum') {
          return Questions[i].answers;
        }
      }
    }
    return [];
  };

  // 選択済みDandruff : フケ（なしかそれ以外か）
  const getSelectedDandruff = () => {
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.scalpDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.scalpDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions;
      for (let i = 0; i < Questions.length; i += 1) {
        if (Questions[i].slug === 'fq-dandruff') {
          return Questions[i].answers;
        }
      }
    }
    return [];
  };

  // 選択済みDensity : 髪の本数
  const getSelectedDensity = () => {
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.scalpDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.scalpDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions;
      for (let i = 0; i < Questions.length; i += 1) {
        if (Questions[i].slug === 'fq-density') {
          return Questions[i].answers;
        }
      }
    }
    return [];
  };

  // 選択済みThick : 髪の太さ
  const getSelectedThick = () => {
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.scalpDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
      stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.scalpDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis &&
        stylistDiagnosisResults.result.scalpDiagnosis.stylistDiagnosis.Questions;
      for (let i = 0; i < Questions.length; i += 1) {
        if (Questions[i].slug === 'fq-thick') {
          return Questions[i].answers;
        }
      }
    }
    return [];
  };

  // 選択済みThick : 仕上がりの軽さ
  const getSelectedMoist = () => {
    if (
      stylistDiagnosisResults &&
      stylistDiagnosisResults.result &&
      stylistDiagnosisResults.result.hairDiagnosis &&
      stylistDiagnosisResults.result.hairDiagnosis.hearing &&
      stylistDiagnosisResults.result.hairDiagnosis.hearing.Questions
    ) {
      const Questions =
        stylistDiagnosisResults &&
        stylistDiagnosisResults.result &&
        stylistDiagnosisResults.result.hairDiagnosis &&
        stylistDiagnosisResults.result.hairDiagnosis.hearing &&
        stylistDiagnosisResults.result.hairDiagnosis.hearing.Questions;
      for (let i = 0; i < Questions.length; i += 1) {
        if (Questions[i].slug === 'fq-wantlight') {
          return Questions[i].answers;
        }
      }
    }
    return [];
  };

  // 配列1に配列2のどれかが存在するか否か
  const includesByArray = (arr, arr2) => {
    if (!arr || !arr2) return false;
    for (let i = 0; i < arr.length; i += 1) {
      if (arr2.includes(arr[i]) === true) {
        return true;
      }
    }
    return false;
  };

  // サロンセッティングにアイテムが存在するか否か
  const getIsExistItemBySetting = (slug, setting) => {
    if (!setting) return false;
    if (setting.reduce((nv, t) => (slug === t.slug ? t : nv), '')) {
      return true;
    }
    return false;
  };

  // 診断ロジック : Salon Solution Hair
  const getSalonSolutionHairResult = children => {
    // console.log('診断ロジック : Salon Solution Hair');
    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];

      // 条件 : Activity
      // console.log('Activity', child.condition, getSelectedActivity(), child.condition && child.condition.includes(getSelectedActivity()));
      if (child.name === 'Activity' && (!child.condition || child.condition.includes(getSelectedActivity()) === true)) {
        if (child.recommendedResults) {
          return {
            recommendedResults: child.recommendedResults,
            otherResults: child.otherResults,
          };
        }
        for (let j = 0; j < child.children.length; j += 1) {
          const child2 = child.children[j];

          // 条件 : Time
          // console.log('Time', child2.condition, getSelectedTime(), child2.condition && child2.condition.includes(getSelectedTime()));
          if (child2.name === 'Time' && (!child2.condition || child2.condition.includes(getSelectedTime()) === true)) {
            if (child2.recommendedResults) {
              return {
                recommendedResults: child2.recommendedResults,
                otherResults: child2.otherResults,
              };
            }
            for (let s = 0; s < child2.children.length; s += 1) {
              const child3 = child2.children[s];

              // 条件 : Wants to be "Resilience"
              // console.log('Resilience', child3.condition, getSelectedResilience(), includesByArray(child3.condition, getSelectedResilience()));
              if (
                child3.name === 'Wants to be "Resilience"' &&
                (!child3.condition || includesByArray(child3.condition, getSelectedResilience()) === true)
              ) {
                if (child3.recommendedResults) {
                  return {
                    recommendedResults: child3.recommendedResults,
                    otherResults: child3.otherResults,
                  };
                }
                for (let k = 0; k < child3.children.length; k += 1) {
                  const child4 = child3.children[k];

                  // 条件 : Damage Level
                  // console.log('DamageLevel', child4.condition, getSelectedDamageLevel(), includesByArray(child4.condition, getSelectedDamageLevel()));
                  if (
                    child4.name === 'Damage Level' &&
                    (!child4.condition || includesByArray(child4.condition, getSelectedDamageLevel()) === true)
                  ) {
                    if (child4.recommendedResults) {
                      return {
                        recommendedResults: child4.recommendedResults,
                        otherResults: child4.otherResults,
                      };
                    }
                    return {
                      recommendedResults: null,
                      otherResults: null,
                    };
                  }
                }
              }
            }
          }
        }
      }
    }
    return {
      recommendedResults: null,
      otherResults: null,
    };
  };

  // 診断ロジック : Salon Solution Items Hair
  const getSalonSolutionItemsHairResult = children => {
    // console.log('診断ロジック : Salon Solution Items Hair');
    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];

      // 条件 : Activity
      // console.log('Activity', child.condition, getSelectedActivity(), child.condition && child.condition.includes(getSelectedActivity()));
      if (child.name === 'Activity' && (!child.condition || child.condition.includes(getSelectedActivity()) === true)) {
        if (child.recommendedResults) {
          return {
            recommendedResults: child.recommendedResults,
            otherResults: child.otherResults,
          };
        }
        for (let j = 0; j < child.children.length; j += 1) {
          const child2 = child.children[j];

          // 条件 : Concerns
          // console.log('Concerns', child2.condition, getSelectedConcerns(), includesByArray(child2.condition, getSelectedConcerns()));
          if (
            child2.name === 'Concerns' &&
            (!child2.condition || includesByArray(child2.condition, getSelectedConcerns()) === true)
          ) {
            if (child2.recommendedResults) {
              return {
                recommendedResults: child2.recommendedResults,
                otherResults: child2.otherResults,
              };
            }
            for (let s = 0; s < child2.children.length; s += 1) {
              const child3 = child2.children[s];

              // 条件 : Fizziness
              // console.log('Fizziness', child3.condition, getSelectedFizziness(), includesByArray(child3.condition, getSelectedFizziness()));
              if (
                child3.name === 'Fizziness' &&
                (!child3.condition || includesByArray(child3.condition, getSelectedFizziness()) === true)
              ) {
                if (child3.recommendedResults) {
                  return {
                    recommendedResults: child3.recommendedResults,
                    otherResults: child3.otherResults,
                  };
                }
                for (let k = 0; k < child3.children.length; k += 1) {
                  const child4 = child3.children[k];

                  // 条件 : Wants to be "Resilience"
                  // console.log('Wants to be "Resilience"', child4.condition, getSelectedResilience(), includesByArray(child4.condition, getSelectedResilience()));
                  if (
                    child4.name === 'Wants to be "Resilience"' &&
                    (!child4.condition || includesByArray(child4.condition, getSelectedResilience()) === true)
                  ) {
                    if (child4.recommendedResults) {
                      return {
                        recommendedResults: child4.recommendedResults,
                        otherResults: child4.otherResults,
                      };
                    }
                    for (let n = 0; n < child4.children.length; n += 1) {
                      const child5 = child4.children[n];

                      // 条件 : Wants to be "Moist"
                      // console.log('Wants to be "Moist"', child5.condition, getSelectedMoist(), includesByArray(child5.condition, getSelectedMoist()));
                      if (
                        child5.name === 'Wants to be "Moist"' &&
                        (!child5.condition || includesByArray(child5.condition, getSelectedMoist()) === true)
                      ) {
                        if (child5.recommendedResults) {
                          return {
                            recommendedResults: child5.recommendedResults,
                            otherResults: child5.otherResults,
                          };
                        }
                        return {
                          recommendedResults: null,
                          otherResults: null,
                        };
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return {
      recommendedResults: null,
      otherResults: null,
    };
  };

  // 診断ロジック : Salon Solution Scalp
  const getSalonSolutionScalpResult = children => {
    // console.log('診断ロジック : Salon Solution Scalp');
    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];

      // 条件 : Activity
      // console.log('Activity', child.condition, getSelectedActivity(), child.condition && child.condition.includes(getSelectedActivity()));
      if (child.name === 'Activity' && (!child.condition || child.condition.includes(getSelectedActivity()) === true)) {
        if (child.recommendedResults) {
          return {
            recommendedResults: child.recommendedResults,
            otherResults: child.otherResults,
          };
        }
        for (let j = 0; j < child.children.length; j += 1) {
          const child2 = child.children[j];

          // 条件 : Time
          // console.log('Time', child2.condition, getSelectedTime(), child2.condition && child2.condition.includes(getSelectedTime()));
          if (child2.name === 'Time' && (!child2.condition || child2.condition.includes(getSelectedTime()) === true)) {
            if (child2.recommendedResults) {
              return {
                recommendedResults: child2.recommendedResults,
                otherResults: child2.otherResults,
              };
            }
            for (let s = 0; s < child2.children.length; s += 1) {
              const child3 = child2.children[s];

              // 条件 : Wants to be
              // console.log('WantToBe', child3.condition, getSelectedWantToBe(), includesByArray(child3.condition, getSelectedWantToBe()));
              if (
                child3.name === 'Wants to be' &&
                (!child3.condition || includesByArray(child3.condition, getSelectedWantToBe()) === true)
              ) {
                if (child3.recommendedResults) {
                  return {
                    recommendedResults: child3.recommendedResults,
                    otherResults: child3.otherResults,
                  };
                }
                for (let k = 0; k < child3.children.length; k += 1) {
                  const child4 = child3.children[k];

                  // 条件 : Redness
                  // console.log('Redness', child4.condition, getSelectedRedness(), includesByArray(child4.condition, getSelectedRedness()));
                  if (
                    child4.name === 'Redness' &&
                    (!child4.condition || includesByArray(child4.condition, getSelectedRedness()) === true)
                  ) {
                    // console.log('child4.recommendedResults', child4.recommendedResults);
                    // console.log('child4.otherResults', child4.otherResults);
                    return {
                      recommendedResults: child4.recommendedResults || null,
                      otherResults: child4.otherResults || null,
                    };
                    // if (child4.recommendedResults) {
                    //   return {
                    //     recommendedResults: child4.recommendedResults,
                    //     otherResults: child4.otherResults,
                    //   };
                    // }
                    // return {
                    //   recommendedResults: null,
                    //   otherResults: null,
                    // };
                  }
                }
              }
            }
          }
        }
      }
    }
    return {
      recommendedResults: null,
      otherResults: null,
    };
  };

  // 診断ロジック : Salon Solution Items Scalp
  const getSalonSolutionItemsScalpResult = children => {
    // console.log('診断ロジック : Salon Solution Items Scalp');
    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];

      // 条件 : Wants to be
      // console.log('Wants to be', child.condition, getSelectedWantToBe(), includesByArray(child.condition, getSelectedWantToBe()));
      if (
        child.name === 'Wants to be' &&
        (!child.condition || includesByArray(child.condition, getSelectedWantToBe()) === true)
      ) {
        if (child.recommendedResults) {
          return {
            recommendedResults: child.recommendedResults,
            otherResults: child.otherResults,
          };
        }
        for (let j = 0; j < child.children.length; j += 1) {
          const child2 = child.children[j];

          // 条件 : Oillness
          // console.log('Oillness', child2.condition, getSelectedOillness(), includesByArray(child2.condition, getSelectedOillness()));
          if (
            child2.name === 'Oillness' &&
            (!child2.condition || includesByArray(child2.condition, getSelectedOillness()) === true)
          ) {
            if (child2.recommendedResults) {
              return {
                recommendedResults: child2.recommendedResults,
                otherResults: child2.otherResults,
              };
            }
            for (let s = 0; s < child2.children.length; s += 1) {
              const child3 = child2.children[s];

              // 条件 : Dandrull
              // console.log('Dandrull', child3.condition, getSelectedDandruff(), includesByArray(child3.condition, getSelectedDandruff()));
              if (
                child3.name === 'Dandrull' &&
                (!child3.condition || includesByArray(child3.condition, getSelectedDandruff()) === true)
              ) {
                if (child3.recommendedResults) {
                  return {
                    recommendedResults: child3.recommendedResults,
                    otherResults: child3.otherResults,
                  };
                }
                return {
                  recommendedResults: null,
                  otherResults: null,
                };
              }
            }
          }
        }
      }
    }
    return {
      recommendedResults: null,
      otherResults: null,
    };
  };

  // 診断ロジック : Home Care Items Hair
  const getHomeCareItemsHairResult = children => {
    // console.log('診断ロジック : Home Care Items Hair', children);
    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];

      // 条件 : Mask
      // console.log('Mask', child.condition, selectedItem.slug, child.condition && child.condition.includes(selectedItem.slug));
      if (child.category === 'Mask' && child.condition.includes(selectedItem.slug) === true) {
        if (child.recommendedResults) {
          return {
            recommendedResults: child.recommendedResults,
            otherResults: child.otherResults || null,
          };
        }
        return {
          recommendedResults: null,
          otherResults: null,
        };
      }
    }
    return {
      recommendedResults: null,
      otherResults: null,
    };
  };

  // 診断ロジック（クイック診断） : Hair Care Items Hair Quick
  const getHomeCareItemsHairResultQuick = children => {
    // console.log('診断ロジック（クイック診断） : Hair Care Items Hair Quick');
    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];

      // 条件 : Activity
      // console.log('Activity', child.condition, getSelectedActivity(), includesByArray(child.condition, getSelectedActivity()));
      if (
        child.name === 'Activity' &&
        (child.condition === null || child.condition.includes(getSelectedActivity()) === true)
      ) {
        if (child.children === null && child.recommendedResults !== null) {
          return {
            recommendedResults: child.recommendedResults,
            otherResults: child.otherResults || null,
          };
        }
        for (let j = 0; j < child.children.length; j += 1) {
          const child2 = child.children[j];

          // 条件 : Concerns
          // console.log('Concerns', child2.condition, getSelectedConcerns(), includesByArray(child2.condition, getSelectedConcerns()));
          if (
            child2.name === 'Concerns' &&
            (!child2.condition || includesByArray(child2.condition, getSelectedConcerns()) === true)
          ) {
            if (child2.recommendedResults) {
              return {
                recommendedResults: child2.recommendedResults,
                otherResults: child2.otherResults,
              };
            }
            return {
              recommendedResults: null,
              otherResults: null,
            };
          }
        }
      }
    }
    return {
      recommendedResults: null,
      otherResults: null,
    };
  };

  // 診断ロジック : Home Care Items Scalp
  const getHomeCareItemsScalpResult = children => {
    // console.log('診断ロジック : Home Care Items Scalp');
    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];

      // 条件 : Wants to be
      let selectedWantToBe = getSelectedWantToBe() || null;
      if (!selectedWantToBe || selectedWantToBe.length <= 0) {
        // クイック診断の場合は自動的に希望項目を設定
        selectedWantToBe = ['ans-relux'];
      }
      // console.log('WantToBe', child.condition, getSelectedWantToBe(), includesByArray(child.condition, selectedWantToBe));
      // console.log('selectedWantToBe', selectedWantToBe);
      if (child.name === 'Wants to be' && includesByArray(child.condition, selectedWantToBe) === true) {
        for (let j = 0; j < child.children.length; j += 1) {
          const child2 = child.children[j];
          if (selectedItem && selectedItem.slug) {
            // 条件 : Pre-Cleanse,shampoo
            // console.log('Pre-Cleanse,shampoo', child2.condition, selectedItem.slug, child2.condition && child2.condition.includes(selectedItem.slug));
            if (child2.category === 'Pre-Cleanse,shampoo' && child2.condition.includes(selectedItem.slug) === true) {
              if (child2.recommendedResults) {
                return {
                  recommendedResults: child2.recommendedResults,
                  otherResults: child2.otherResults || null,
                };
              }
              return {
                recommendedResults: null,
                otherResults: null,
              };
            }
          }
          if (child2.category === 'Treatment') {
            // 条件 : Treatment
            // console.log('Treatment');
            if (child2.recommendedResults) {
              return {
                recommendedResults: child2.recommendedResults,
                otherResults: child2.otherResults || null,
              };
            }
            return {
              recommendedResults: null,
              otherResults: null,
            };
          }
        }
      }
    }
    return {
      recommendedResults: null,
      otherResults: null,
    };
  };

  // 診断ロジック（クイック診断） : Hair Care Items Scalp Quick
  const getHomeCareItemsScalpResultQuick = children => {
    // console.log('診断ロジック（クイック診断） : Hair Care Items Scalp Quick');
    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];

      // 条件 : Activity
      // console.log('Activity', child.condition, getSelectedActivity(), includesByArray(child.condition, getSelectedActivity()));
      if (
        child.name === 'Activity' &&
        (child.condition === null || child.condition.includes(getSelectedActivity()) === true)
      ) {
        if (child.children === null && child.recommendedResults !== null) {
          return {
            recommendedResults: child.recommendedResults,
            otherResults: child.otherResults || null,
          };
        }
        for (let j = 0; j < child.children.length; j += 1) {
          const child2 = child.children[j];

          // 条件 : Concerns
          // console.log('Concerns', child2.condition, getSelectedConcerns(), includesByArray(child2.condition, getSelectedConcerns()));
          if (
            child2.name === 'Concerns' &&
            (!child2.condition || includesByArray(child2.condition, getSelectedConcerns()) === true)
          ) {
            if (child2.recommendedResults) {
              return {
                recommendedResults: child2.recommendedResults,
                otherResults: child2.otherResults,
              };
            }
            return {
              recommendedResults: null,
              otherResults: null,
            };
          }
        }
      }
    }
    return {
      recommendedResults: null,
      otherResults: null,
    };
  };

  // 診断ロジック（診断結果、頭皮、現在の状態）
  const getCurrentScalpStatus = children => {
    // console.log('診断ロジック（診断結果、頭皮、現在の状態） : Current Scalp Status');
    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];

      // 条件 : Sebum
      // console.log('Sebum', child.condition, getSelectedOillness(), child.condition && includesByArray(child.condition, getSelectedOillness()));
      if (
        child.name === 'Sebum' &&
        (child.condition === null || includesByArray(child.condition, getSelectedOillness()) === true)
      ) {
        if (child.children === null && child.recommendedResults !== null) {
          return {
            recommendedResults: child.recommendedResults,
            otherResults: null,
          };
        }
        for (let j = 0; j < child.children.length; j += 1) {
          const child2 = child.children[j];

          // 条件 : Dandruff
          // console.log('Dandruff', child2.condition, getSelectedDandruff(), child2.condition && includesByArray(child2.condition, getSelectedDandruff()));
          if (
            child2.name === 'Dandruff' &&
            (child2.condition === null || includesByArray(child2.condition, getSelectedDandruff()) === true)
          ) {
            if (child2.recommendedResults !== null) {
              return {
                recommendedResults: child2.recommendedResults,
                otherResults: null,
              };
            }
            return {
              recommendedResults: null,
              otherResults: null,
            };
          }
        }
      }
    }
    return {
      recommendedResults: null,
      otherResults: null,
    };
  };

  // 診断ロジック（診断結果、髪の密度と太さ）
  const getCurrentScalpType = children => {
    // console.log('診断ロジック（診断結果、髪の密度と太さ） : Current Scalp Type');
    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];

      // 条件 : Density
      if (
        child.name === 'Density' &&
        (child.condition === null || includesByArray(child.condition, getSelectedDensity()) === true)
      ) {
        if (child.children === null && child.recommendedResults !== null) {
          return {
            recommendedResults: child.recommendedResults,
            otherResults: null,
          };
        }
        for (let j = 0; j < child.children.length; j += 1) {
          const child2 = child.children[j];

          // 条件 : Diameter
          if (
            child2.name === 'Diameter' &&
            (child2.condition === null || includesByArray(child2.condition, getSelectedThick()) === true)
          ) {
            if (child2.recommendedResults !== null) {
              return {
                recommendedResults: child2.recommendedResults,
                otherResults: null,
              };
            }
            return {
              recommendedResults: null,
              otherResults: null,
            };
          }
        }
      }
    }
    return {
      recommendedResults: null,
      otherResults: null,
    };
  };

  let result = null;
  let setting = null;
  let isHomeCare = false;
  let isCareMenuItems = false;
  let isStatus = false;
  for (let i = 0; i < sublimicDiagnosisLogics[0].diagnosisLogics.length; i += 1) {
    if (sublimicDiagnosisLogics[0].diagnosisLogics[i].logicName === logicName && logicName === 'Salon Solution Hair') {
      // 診断ロジック : Salon Solution Hair
      result = getSalonSolutionHairResult(sublimicDiagnosisLogics[0].diagnosisLogics[i].decisionTree.children);
      if (authSalonSettingData && authSalonSettingData.salonMenus && authSalonSettingData.salonMenus.treatments) {
        setting = authSalonSettingData.salonMenus.treatments;
      }
      isHomeCare = false;
    } else if (
      sublimicDiagnosisLogics[0].diagnosisLogics[i].logicName === logicName &&
      logicName === 'Salon Solution Items Hair'
    ) {
      // 診断ロジック : Salon Solution Items Hair
      result = getSalonSolutionItemsHairResult(sublimicDiagnosisLogics[0].diagnosisLogics[i].decisionTree.children);
      if (authSalonSettingData && authSalonSettingData.salonMenus && authSalonSettingData.salonMenus.treatments) {
        setting = authSalonSettingData.salonMenus.treatments;
      }
      isCareMenuItems = true;
    } else if (
      sublimicDiagnosisLogics[0].diagnosisLogics[i].logicName === logicName &&
      logicName === 'Salon Solution Scalp'
    ) {
      // 診断ロジック : Salon Solution Scalp
      result = getSalonSolutionScalpResult(sublimicDiagnosisLogics[0].diagnosisLogics[i].decisionTree.children);
      if (authSalonSettingData && authSalonSettingData.salonMenus && authSalonSettingData.salonMenus.spas) {
        setting = authSalonSettingData.salonMenus.spas;
      }
      isHomeCare = false;
    } else if (
      sublimicDiagnosisLogics[0].diagnosisLogics[i].logicName === logicName &&
      logicName === 'Salon Solution Items Scalp'
    ) {
      // 診断ロジック : Salon Solution Items Scalp
      result = getSalonSolutionItemsScalpResult(sublimicDiagnosisLogics[0].diagnosisLogics[i].decisionTree.children);
      if (authSalonSettingData && authSalonSettingData.salonMenus && authSalonSettingData.salonMenus.treatments) {
        setting = authSalonSettingData.salonMenus.treatments;
      }
      isCareMenuItems = true;
    } else if (
      sublimicDiagnosisLogics[0].diagnosisLogics[i].logicName === logicName &&
      logicName === 'Home Care Items Hair'
    ) {
      // 診断ロジック : Home Care Items Hair
      result = getHomeCareItemsHairResult(sublimicDiagnosisLogics[0].diagnosisLogics[i].decisionTree.children);
      if (authSalonSettingData && authSalonSettingData.homeCareItems) {
        setting = authSalonSettingData.homeCareHairSlugs;
      }
      isHomeCare = true;
    } else if (
      sublimicDiagnosisLogics[0].diagnosisLogics[i].logicName === logicName &&
      logicName === 'Hair Care Items Hair Quick'
    ) {
      // 診断ロジック（クイック診断） : Hair Care Items Hair Quick
      result = getHomeCareItemsHairResultQuick(sublimicDiagnosisLogics[0].diagnosisLogics[i].decisionTree.children);
      if (authSalonSettingData && authSalonSettingData.homeCareItems) {
        setting = authSalonSettingData.homeCareHairSlugs;
      }
      isHomeCare = true;
    } else if (
      sublimicDiagnosisLogics[0].diagnosisLogics[i].logicName === logicName &&
      logicName === 'Home Care Items Scalp'
    ) {
      // 診断ロジック : Home Care Items Scalp
      result = getHomeCareItemsScalpResult(sublimicDiagnosisLogics[0].diagnosisLogics[i].decisionTree.children);
      if (authSalonSettingData && authSalonSettingData.homeCareItems) {
        setting = authSalonSettingData.homeCareScalpSlugs;
      }
      isHomeCare = true;
    } else if (
      sublimicDiagnosisLogics[0].diagnosisLogics[i].logicName === logicName &&
      logicName === 'Hair Care Items Scalp Quick'
    ) {
      // 診断ロジック（クイック診断） : Hair Care Items Scalp Quick
      result = getHomeCareItemsScalpResultQuick(sublimicDiagnosisLogics[0].diagnosisLogics[i].decisionTree.children);
      if (authSalonSettingData && authSalonSettingData.homeCareItems) {
        setting = authSalonSettingData.homeCareScalpSlugs;
      }
      isHomeCare = true;
    } else if (
      sublimicDiagnosisLogics[0].diagnosisLogics[i].logicName === logicName &&
      logicName === 'Current Scalp Status'
    ) {
      // 診断ロジック（診断結果、頭皮、現在の状態） : Current Scalp Status
      result = getCurrentScalpStatus(sublimicDiagnosisLogics[0].diagnosisLogics[i].decisionTree.children);
      // console.log('診断ロジック（診断結果、頭皮、現在の状態）の結果', result);
      isStatus = true;
    } else if (
      sublimicDiagnosisLogics[0].diagnosisLogics[i].logicName === logicName &&
      logicName === 'Density and Diameter'
    ) {
      // 診断ロジック（診断結果、髪の密度と太さ） : Current Scalp Status
      result = getCurrentScalpType(sublimicDiagnosisLogics[0].diagnosisLogics[i].decisionTree.children);
      // console.log('診断ロジック（診断結果、髪の密度と太さ）の結果', result);
      isStatus = true;
    }
  }

  // 頭皮、現在の状態におけるオススメアイテム取得
  if (isStatus) {
    return result;
  }

  // 各ケアメニューのアイテム取得
  if (isCareMenuItems) {
    return result;
  }

  // サロンセッティングでフィルタリング
  if (!isHomeCare) {
    if (result && setting) {
      // console.log('サロンセッティングでフィルタリングをかける前の診断ロジック結果', result);
      // console.log('フィルタリング内容', setting);
      // サロンセッティングを元にレコメンドアイテム設定
      const recommendedResults = [];
      const otherResults = [];
      if (result.recommendedResults) {
        if (getIsExistItemBySetting(result.recommendedResults[0].slug, setting)) {
          // 診断ロジックから取得したレコメンドアイテムがサロンセッティングに存在する場合は、通常通りに診断ロジックから取得したレコメンドアイテムを設定
          recommendedResults.push(result.recommendedResults[0]);
        } else if (result.otherResults) {
          // 診断ロジックから取得したレコメンドアイテムサロンセッティングに存在しない場合は、一番金額が診断ロジックから取得した他のアイテムから、金額の一番高いアイテムをレコメンドアイテムに設定
          setting = setting.sort((a, b) => {
            if (Number(a.price) < Number(b.price)) return 1;
            if (Number(a.price) > Number(b.price)) return -1;
            return 0;
          });
          for (let i = 0; i < setting.length; i += 1) {
            if (getIsExistItemBySetting(setting[i].slug, result.otherResults)) {
              recommendedResults.push(setting[i]);
              break;
            }
          }
        }
        // サロンセッティングを元に他のアイテム設定
        if (result.otherResults) {
          result.otherResults.map(otherResult => {
            if (getIsExistItemBySetting(otherResult.slug, setting)) {
              if (
                recommendedResults &&
                recommendedResults[0] &&
                recommendedResults[0].slug &&
                recommendedResults[0].slug !== otherResult.slug
              ) {
                otherResults.push(otherResult);
              }
            }
            return null;
          });
        }
      } else if (result.otherResults) {
        // サロンセッティングを元に他のアイテム設定
        if (result.otherResults) {
          result.otherResults.map(otherResult => {
            if (getIsExistItemBySetting(otherResult.slug, setting)) {
              otherResults.push(otherResult);
            }
            return null;
          });
        }
      }
      // 一つも引っかからない場合は、サロンセッティングのうち一番高いものを一つだけ表示
      if ((!recommendedResults || recommendedResults.length <= 0) && (!otherResults || otherResults.length <= 0)) {
        // console.log('一つも引っかからない場合は、サロンセッティングのうち一番高いものを一つだけ表示');
        setting = setting.sort((a, b) => {
          if (Number(a.price) < Number(b.price)) return 1;
          if (Number(a.price) > Number(b.price)) return -1;
          return 0;
        });
        return {
          recommendedResults: [{ slug: setting[0].slug, category: setting[0].category }],
          otherResults: null,
        };
      }

      // サロンセッティングでフィルタリングをかけた結果を返す
      return {
        recommendedResults: recommendedResults && recommendedResults.length >= 1 ? recommendedResults : null,
        otherResults: otherResults && otherResults.length >= 1 ? otherResults : null,
      };
    } else if (result) {
      // サロンセッティングが無い場合は診断ロジック結果を返す
      return result;
    }
  } else if (isHomeCare) {
    return result;
    /*
    if (result && setting) {
      // console.log('サロンセッティングでフィルタリングをかける前の診断ロジック結果（HomeCare）', result);
      // console.log('フィルタリング内容（HomeCare）', setting);
      // サロンセッティングを元にレコメンドアイテム設定
      const recommendedResults = [];
      if (result.recommendedResults) {
        // 診断ロジックから取得したレコメンドアイテムがサロンセッティングに存在する場合は、通常通りに診断ロジックから取得したレコメンドアイテムを設定
        if (setting.includes(result.recommendedResults[0].slug)) {
          recommendedResults.push(result.recommendedResults[0]);
        }
      }
      // サロンセッティングを元に他のアイテム設定
      const otherResults = [];
      setting.map(slug => {
        if (result.recommendedResults) {
          if (result.recommendedResults[0].slug !== slug) {
            otherResults.push({ slug: slug || null });
          }
        } else {
          otherResults.push({ slug: slug || null });
        }
        return null;
      });
      // サロンセッティングでフィルタリングをかけた結果を返す
      return {
        recommendedResults: recommendedResults && recommendedResults.length >= 1 ? recommendedResults : null,
        otherResults: otherResults && otherResults.length >= 1 ? otherResults : null,
      };
    } else if (result) {
      // サロンセッティングが無い場合は診断ロジック結果を返す
      return result;
    }
    */
  }

  return {
    recommendedResults: null,
    otherResults: null,
  };
};



// WEBPACK FOOTER //
// ./src/common/diagnosisLogic.js